export class RelativeKeySelector{
    history:number[] = []
    maxHistory:number
    constructor(maxSelectionHistory:number = 7){
        this.maxHistory = maxSelectionHistory
        this.history = [Math.floor(Math.random() * 11)]
    }
    addToHistory = (position:number) => {
        if(this.history.includes(position)){return}
        this.history.push(position)
        const surplus:number = this.history.length - this.maxHistory
        if(surplus > 0){
            this.history.splice(0, surplus)
        }
    }
    getRandomPosition(currentSelectedPosition:number = 0){
        if(currentSelectedPosition < 0){
            return this.history[this.history.length - 1]
        }
        let positions:number[] = [0,1,2,3,4,6,7,8,9,10,11]
        this.history.forEach((position:number)=>{
            const index:number = positions.indexOf(position)
            if(index > -1){positions.splice(index,1)}
        })
        const randomIndex:number = Math.floor(Math.random() * positions.length)
        const position:number = positions[randomIndex]
        this.addToHistory(position)
        return position
    }
}